import { ChartData } from "../dataset-window/types";
import { IDataSet, PlotDataEx } from "./interfaces";
import { convertKey, convertValue } from "./utils";

export const configMultiScatterChartData = (
  xData: ChartData,
  yData: ChartData,
  colorData: ChartData,
  sizeData: ChartData,
  selectedColorPalette: Array<string>
) => {
  return [createPlotData(xData, yData, colorData, sizeData, selectedColorPalette)];
};

const createPlotData = (xData: ChartData, yData: ChartData, colorData: ChartData, sizeData: ChartData, selectedColorPalette: Array<string>): PlotDataEx => {
  const plotData = {
    name: `${yData.title}`,
    type: "scatter",
    mode: "markers",
    showlegend: true,
    unit: yData.unit,
    hovertemplate: `<b>%{y:.3f}</b>, ${yData.unit} at <b>%{x:.3f}</b>, ${xData.unit}, color: <b>%{marker.color:.3f}</b>, ${colorData.unit}, size: <b>%{marker.size:.3f}</b>, ${sizeData.unit} <br> ${yData.title}, ${yData.unit} at ${xData.title}, ${xData.unit} <br> color: ${colorData.title}, size: ${sizeData.title}<extra></extra>`,
    x: xData.valueArr,
    y: yData.valueArr,
    opacity: 0.7,
    marker: {
      color: colorData.valueArr,
      size: sizeData.valueArr,
    },
  } as PlotDataEx;
  return plotData;
};
